import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Card, PageHeader } from '@mkcore/ui';
import { SlaClasses } from '@/features/support/sla';
import { SupportAddresses } from '@/features/support/addresses';

export const Route = createFileRoute('/_app/support/sla')({ component: SlaPage });

/** The SLA classes (CO-0179): an engagement picks one; one is the default for tickets without. */
function SlaPage() {
  const { t } = useTranslation();
  return (
    <>
      <Link to="/support" className="mb-3 inline-flex items-center gap-1 text-sm text-fg-2 hover:text-fg-1">
        <ArrowLeft className="size-4" /> {t('tickets.title')}
      </Link>
      <PageHeader title={t('sla.settingsTitle')} description={t('sla.classesHint')} />
      <div className="grid gap-6">
        <Card className="p-4">
          <SlaClasses />
        </Card>
        <Card className="p-4">
          <SupportAddresses />
        </Card>
      </div>
    </>
  );
}
